import Validation from "utils/validation.utils";
import locale from "localization";
const initialState = (beginningCashBalance, remarksCashBalance) => {
  return {
    beginningCashBalance: {
      name: "beginningCashBalance",
      value: beginningCashBalance ?? "",
      required: true,
      isPriceValue: true,
      innerLabel: true,
      min: 0,
      max: 99999.99,
      placeholder: "0.00",
      validations: [Validation.required(), Validation.min(0)],
    },

    remarksCashBalance: {
      name: "remarksCashBalance",
      value: remarksCashBalance ?? "",
      label: locale.remarks,
      placeholder: locale.typeYourRemarksHere,
      maxLength: 225,
      required: true,
      validations: [Validation.required()],
    },
  };
};

export default initialState;
